/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LeftBuccalWithRetractors1/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import LeftBuccalWithRetractors from 'DesignSystem/Images/LeftBuccalWithRetractors/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function LeftBuccalWithRetractors1({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/ImageCapture/Questions/Question/Content/Instructions/Illustrations/Illustration/LeftBuccalWithRetractors"
  
}) {
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<LeftBuccalWithRetractors
  viewPath={`${viewPath}/LeftBuccalWithRetractors`}
 width="100%"
 height="100%"
 objectFit="contain"
 marginTop={dtSpaceM}
 marginBottom={dtSpaceM}
 marginLeft="auto"
 marginRight="auto"
/>
{children}
</React.Fragment>)
}